export enum EServerItemStatus {
  PENDING,
  ACTIVE,
  EXPIRED,
  CANCELED,
}

export interface UserServerItem {
  res_id: number;
  product_id: number;
  variation_id: number;
  res_name: string;
  res_ip: string;
  res_port: number;
  res_user: string;
  res_password: string;
  create_time: string;
  res_renew_time: string;
  remark: string;
  status: EServerItemStatus;
}

export enum EServerItemRenewStatus {
  // 否 没有续费操作
  IDLE = 1,
  // 用户续费 需要管理员操作
  PENDING = 2,
}

export interface AdminUserServerItem {
  res_id: number;
  product_id: number;
  variation_id: number;
  res_name: string;
  res_ip: string;
  res_port: number;
  res_user: string;
  res_password: string;
  create_time: string;
  res_renew_time: string;
  remark: string;
  status: EServerItemStatus;
  order_id: number;
  // 来源
  res_type: string;
  // 来源账号
  res_type_name: string;
  user_email: string;
  renew_status: EServerItemRenewStatus;
  // 用户续费时间
  last_renew_time: string;
}

export interface AdminServerItem {
  server_name: string;
  server_ip: string;
  port: number;
  username: string;
  pass: string;
  product_id: number;
  remark: string;

  id: number;
  create_time: string;

  allIpCount: number;
  soldIpCount: number;
}
